import { RegionShared } from "@1games-ru/region-shared";
import { useEffect, useState } from "react";
import rpc from "@1games-ru/rage-rpc";

export default function useShowDocuments() {
  const [document, setDocument] = useState<
    null | typeof RegionShared.Cef.Requests.ShowDocumentsRequest
  >(null);

  useEffect(() => {
    rpc.register(
      RegionShared.Cef.Events.Documents.ShowDocuments,
      (data: typeof RegionShared.Cef.Requests.ShowDocumentsRequest) => {
        console.log(data);
        setDocument(data);
      },
    );

    return () => {
      rpc.unregister(RegionShared.Cef.Events.Documents.ShowDocuments);
    };
  }, []);

  useEffect(() => {
    rpc.register(RegionShared.Cef.Events.Documents.HideDocuments, () => {
      setDocument(null);
    });

    return () => {
      rpc.unregister(RegionShared.Cef.Events.Documents.HideDocuments);
    };
  }, []);

  return { document };
}
